import { watch, unref } from 'vue';
import { useTitle as usePageTitle } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export function useTitle(): void {
  const { t, locale } = useI18n();
  const pageTitle = usePageTitle();
  const { currentRoute } = useRouter();

  watch(
    [currentRoute, locale],
    () => {
      const {
        meta: { title },
      } = unref(currentRoute);

      if (title) {
        pageTitle.value = t(title as string);
      }
    },
    { immediate: false }
  );
}
